import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Stack,
  Box,
  Switch,
  Divider,
} from "../../../../../components";

export default function SelecionarInscricaoEstadualDialog({
  dialogInscricaoEstadual,
  inscricoesEstaduais,
  inscricaoSelecionada,
  setInscricaoSelecionada,
  enderecos,
  confirmarInscricaoEstadual,
}) {
  const getEndereco = (tipo) =>
    enderecos?.find((e) => e.tipoInscricaoEstadual === tipo) ??
    (tipo === "SECUNDARIA"
      ? enderecos?.find((e) => e.tipoInscricaoEstadual === "PRIMARIA")
      : undefined);

  return (
    <Dialog
      open={dialogInscricaoEstadual}
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Selecionar Inscrição Estadual</DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Este cliente possui mais de uma inscrição estadual. Selecione qual
          deseja utilizar nesta nota fiscal.
        </Typography>

        <Stack spacing={1}>
          {Object.keys(inscricoesEstaduais).map(
            (tipoInscricaoEstadual, index) => {
              const endereco = getEndereco(tipoInscricaoEstadual);
              return (
                <Box key={tipoInscricaoEstadual}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      px: 2,
                      py: 1,
                      borderRadius: 2,
                      bgcolor:
                        inscricaoSelecionada?.inscricao ===
                        inscricoesEstaduais[tipoInscricaoEstadual]
                          ? "action.selected"
                          : "transparent",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setInscricaoSelecionada({
                        inscricao: inscricoesEstaduais[tipoInscricaoEstadual],
                        endereco,
                      })
                    }
                  >
                    <Box>
                      <Typography variant="body2" className="mb-2">
                        Inscrição Estadual:{" "}
                        <span className="fw-bold">
                          {inscricoesEstaduais[tipoInscricaoEstadual]}
                        </span>
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        className="fw-bold"
                      >
                        Endereço Vinculado:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {endereco?.logradouro}, {endereco?.numero},{" "}
                        {endereco?.bairro}, {endereco?.cidade} -{" "}
                        {endereco?.estado}
                      </Typography>
                    </Box>

                    <Switch
                      checked={
                        inscricaoSelecionada?.inscricao ===
                        inscricoesEstaduais[tipoInscricaoEstadual]
                      }
                      onChange={() =>
                        setInscricaoSelecionada({
                          inscricao: inscricoesEstaduais[tipoInscricaoEstadual],
                          endereco,
                        })
                      }
                    />
                  </Box>

                  {index < Object.keys(inscricoesEstaduais).length - 1 && (
                    <Divider />
                  )}
                </Box>
              );
            },
          )}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="contained"
          onClick={confirmarInscricaoEstadual}
          fullWidth
        >
          Confirmar inscrição
        </Button>
      </DialogActions>
    </Dialog>
  );
}
